(function () {
  var TOAST_ID = 'bsa-discount-toast';
  var VISIBLE_CLASS = 'bsa-discount-toast--visible';
  var SESSION_KEY = 'bsa_toast_state';
  var MIN_COUNT = 2;
  var AUTO_DISMISS_MS = 4500;

  var toast = document.getElementById(TOAST_ID);
  if (!toast) return;

  var dismissTimer = null;
  var pendingFetch = null;

  function getState() {
    try { return JSON.parse(sessionStorage.getItem(SESSION_KEY)) || {}; }
    catch (e) { return {}; }
  }

  function setState(patch) {
    try {
      var s = Object.assign({}, getState(), patch);
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(s));
    } catch (e) {}
  }

  function showToast() {
    if (dismissTimer) clearTimeout(dismissTimer);
    toast.classList.add(VISIBLE_CLASS);
    dismissTimer = setTimeout(hideToast, AUTO_DISMISS_MS);
  }

  function hideToast() {
    toast.classList.remove(VISIBLE_CLASS);
    dismissTimer = null;
  }

  var closeBtn = toast.querySelector('[data-bsa-toast-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      if (dismissTimer) clearTimeout(dismissTimer);
      hideToast();
    });
  }

  // Initialise prevCount from current session cart state (set by cart-icon.js)
  // so we don't fire the toast for carts that already had 2+ items at page load.
  (function initPrevCount() {
    var state = getState();
    if (typeof state.prevCount === 'number') return;
    try {
      var stored = sessionStorage.getItem('cart-count');
      if (stored) {
        var parsed = JSON.parse(stored);
        var count = parseInt(parsed.value, 10) || 0;
        // If cart already at/above threshold, mark seen so toast won't fire
        // until count drops and rises again.
        setState({ prevCount: count, seen: count >= MIN_COUNT });
      }
    } catch (e) {}
  })();

  function handleItemCount(newCount) {
    var state = getState();
    var prevCount = typeof state.prevCount === 'number' ? state.prevCount : 0;
    var seen = state.seen === true;

    if (newCount < MIN_COUNT) {
      setState({ prevCount: newCount, seen: false });
      return;
    }

    // Show toast only when crossing from below threshold and not yet seen
    if (prevCount < MIN_COUNT && !seen) {
      showToast();
      setState({ prevCount: newCount, seen: true });
    } else {
      setState({ prevCount: newCount });
    }
  }

  document.addEventListener('cart:update', function () {
    if (pendingFetch) pendingFetch.abort();
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    pendingFetch = controller;

    fetch('/cart.js', controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (cart) { handleItemCount(cart.item_count); })
      .catch(function () {});
  });
})();
